import { getText, interpolate } from "shared/lib";

import { useCouncilLocalisation } from "shared/hooks";
import { useAccount } from "@/hooks";

export function PostSentToCouncilHelpMessage() {
  const { conversation } = useAccount();
  const { getLocalisationEntry } = useCouncilLocalisation(conversation);

  return (
    <div className="text-bodylg text-textPrimary flex flex-col gap-6">
      <div className="flex flex-col gap-2">
        <h3 className="text-headingmd">
          {getText("Have a question about planning?")}
        </h3>
        <p>
          {interpolate(
            "If you would like to discuss a planning enquiry or your proposal with a planner, please {{contactCouncilLink}}. When you contact Council, quote your session ID:",
            {
              contactCouncilLink: (
                <a
                  className="text-textLink hover:text-textLinkHover underline"
                  href={getLocalisationEntry("councilContactLink")}
                  rel="noreferrer"
                  tabIndex={0}
                  target="_blank"
                >
                  {getText("contact Council")}
                </a>
              ),
            },
          )}
        </p>
        <span className="border-interactiveBorder bg-interfaceWhite w-min whitespace-nowrap rounded border px-2 py-1.5 font-medium">
          {conversation?.identifier?.toUpperCase() || ""}
        </span>
        <p>
          {interpolate(
            "You may also find an answer to your question in the {{planningWebsiteLink}} of the council’s website.",
            {
              planningWebsiteLink: (
                <a
                  className="text-textLink hover:text-textLinkHover underline"
                  href={getLocalisationEntry("councilPlanningWebsite")}
                  rel="noreferrer"
                  tabIndex={0}
                  target="_blank"
                >
                  {getText("planning section")}
                </a>
              ),
            },
          )}
        </p>
      </div>

      <div className="flex flex-col gap-2">
        <h3 className="text-headingmd">
          {getText("Is there an issue, or do you have feedback?")}
        </h3>
        <p>
          {interpolate(
            "In partnership with your council, this service is managed by {{myLotLink}}, an Australian technology company.",
            {
              myLotLink: (
                <a
                  className="text-textLink hover:text-textLinkHover underline"
                  href="https://mylot.ai"
                  rel="noreferrer"
                  tabIndex={0}
                  target="_blank"
                >
                  {getText("myLot")}
                </a>
              ),
            },
          )}
        </p>
        <p>
          {interpolate(
            "If you’re experiencing an issue with the service or if you would like to provide feedback, please email {{helpEmailLink}}. We’ll get back to you as soon as we can.",
            {
              helpEmailLink: (
                <a
                  className="text-textLink hover:text-textLinkHover underline"
                  href="mailto:help@mylot.ai"
                >
                  help@mylot.ai
                </a>
              ),
            },
          )}
        </p>
      </div>
    </div>
  );
}
